<template>
    <v-container class="pa-4 fill-height">
      <v-row align="center" justify="center">
        <v-col cols="12" sm="6" md="4">
          <h2 class="text-center mb-4">Redefinir senha</h2>
          <v-form @submit.prevent="onSubmit">
            <v-text-field
              v-model="newPassword"
              :type="showPassword ? 'text' : 'password'"
              label="Nova senha"
              required
              :append-inner-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
              @click:append-inner="() => showPassword = !showPassword"
              @input="error = ''"
            />
            <v-text-field
              v-model="confirmPassword"
              :type="showPassword ? 'text' : 'password'"
              label="Confirme a senha"
              required
              @input="error = ''"
            />
            <v-alert v-if="error" type="error" dense outlined>{{ error }}</v-alert>
            <v-alert v-if="success" type="success" dense outlined>{{ success }}</v-alert>
            <div class="text-center mt-4">
              <v-btn type="submit" color="primary">Redefinir</v-btn>
            </div>
          </v-form>
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script setup>
  import { ref, onMounted } from 'vue';
  import { useRoute, useRouter } from 'vue-router';
  import { confirmPasswordReset } from '../services/api';
  
  const route = useRoute();
  const router = useRouter();
  
  const token = ref('');
  const newPassword = ref('');
  const confirmPassword = ref('');
  const showPassword = ref(false);
  const error = ref('');
  const success = ref('');
  
  onMounted(() => {
    token.value = route.query.token || '';
    if (!token.value) {
      error.value = 'Token não fornecido.';
    }
  });
  
  async function onSubmit() {
    error.value = '';
    success.value = '';
    if (newPassword.value !== confirmPassword.value) {
      error.value = 'As senhas não coincidem.';
      return;
    }
    try {
      const res = await confirmPasswordReset(token.value, newPassword.value);
      success.value = res.message;
      setTimeout(() => router.push({ name: 'Login' }), 2000);
    } catch (err) {
      error.value = err.message;
    }
  }
  </script>
  